import React from "react";
import { I18n } from "react-redux-i18n";
import { isUserVerified } from "../assets/userAvatarUtils";
import verifiedBadgeLogo from "../assets/logo_godiway_celeste_blanco_51_44.png";
import "./styles/UserAvatar.css";

function UserAvatar({
  src,
  alt = "",
  verified,
  user,
  size = "md",
  className = "",
  imgClassName = "",
  initials = "",
}) {
  const isVerified = verified !== undefined ? Boolean(verified) : isUserVerified(user);

  return (
    <span
      className={`user-avatar user-avatar--${size}${
        isVerified ? " user-avatar--verified" : ""
      } ${className}`.trim()}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          className={`user-avatar__img ${imgClassName}`.trim()}
        />
      ) : (
        <span className={`user-avatar__placeholder ${imgClassName}`.trim()}>
          {initials}
        </span>
      )}

      {isVerified && (
        <span
          className="user-avatar__badge"
          title={I18n.t("user_verified_badge")}
          aria-label={I18n.t("user_verified_badge")}
        >
          <img
            src={verifiedBadgeLogo}
            alt=""
            className="user-avatar__badge-img"
          />
        </span>
      )}
    </span>
  );
}

export default UserAvatar;
